export default "__VITE_ASSET__adcbed73__"